import { SHOPIFY_URL } from "@/constants/config";

/**
 * Turns a dog name into a Shopify-compatible collection slug.
 * Uses "team-<name>" convention (e.g., "Team Spike", "Team Daisy Mae").
 * Handles parenthesized nicknames like "Junior (aka Nova)" -> "team-junior".
 */
export function dogCollectionSlug(name) {
  if (!name) return "";
  const first = name.split(/[(\-]/)[0].trim();
  return "team-" + first
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\s+/g, "-");
}

/**
 * Builds the Shopify collection URL for a given dog.
 * Example: "Junior (aka Nova)" -> https://…/collections/team-junior
 */
export function dogShopUrl(name) {
  return `${SHOPIFY_URL.replace(/\/$/, "")}/collections/${dogCollectionSlug(name)}`;
}
